export const STRONG_PASS = "^(?=.{14,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};:,.?/]).*$"
export const MEDIUM_PASS = "^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};:,.?/]).*$"
export const WEAK_PASS = "^(?=.{4,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*$"
